// The page is in an iFrame
if (window.location !== window.parent.location) {
  window.iFrameResizer = {
    heightCalculationMethod: 'lowestElement',
  };
  require('iframe-resizer/js/iframeResizer.contentWindow.min.js');
}
